<div [ngClass]="{ 'high-contrast': contraste }">
  <app-cabecalho (altoContraste)="altoContraste($event)" [contraste]="contraste"></app-cabecalho>
  <app-menu></app-menu>
  <div class="maincontent" tabindex="0">
    <app-spinner *ngIf="loading"></app-spinner>
    <router-outlet></router-outlet>
  </div>
  <app-rodape></app-rodape>
</div>